import { Stack } from '@dtx-company/design-system/src'
import { ReactNode } from 'react'

export interface PlanPurchaseExperienceSummaryLineContainerProps {
  children?: ReactNode
}

export function PlanPurchaseExperienceSummaryLineContainer(
  props: PlanPurchaseExperienceSummaryLineContainerProps
): JSX.Element {
  return (
    <Stack
      sx={{
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        flexDirection: 'row'
      }}
      gap={4}
    >
      {props.children}
    </Stack>
  )
}
